webpackJsonp([77866191142387],{

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/social1.e507841e.jpg";

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/social2.e54cf359.jpg";

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/social3.3982976c.jpg";

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _componentsModule = __webpack_require__(6);
	
	var _componentsModule2 = _interopRequireDefault(_componentsModule);
	
	var _social = __webpack_require__(523);
	
	var _social2 = _interopRequireDefault(_social);
	
	var _social3 = __webpack_require__(524);
	
	var _social4 = _interopRequireDefault(_social3);
	
	var _social5 = __webpack_require__(525);
	
	var _social6 = _interopRequireDefault(_social5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPage = function SocialPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      { className: _componentsModule2.default.pagetitle },
	      'Banquet Dinner'
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: _componentsModule2.default.nomarginb },
	      'Thursday, 30 August 2018 \u2013 7:00pm \u2013 10:30pm'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Venue: Grouse Mountain- The peak of Vancouver'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'A social event and banquet will be held on the evening of ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '30 August 2018'
	      ),
	      ' at ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.grousemountain.com/', target: '_blank' },
	        'Grouse Mountain- The peak of Vancouver'
	      ),
	      '.'
	    ),
	    _react2.default.createElement('img', { src: _social2.default, className: _componentsModule2.default.content_image, alt: '' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Just 15 minutes from downtown, Vancouver\'s Grouse Mountain offers the perfect destination for a truly rewarding and memorable experience.'
	    ),
	    _react2.default.createElement('img', { src: _social4.default, className: _componentsModule2.default.content_image, alt: '' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Transportation will be organized for the workshop attendees and the travel and banquet expenses are included in the registration costs.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Note: Additional banquet tickets can be purchased at $90 through the ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/registration' },
	        'Registration page'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'strong',
	        null,
	        'Transportation:'
	      ),
	      ' Buses will depart from the SFU Segal Building at approximately 18:15. Departure from Grouse Mountain will be approximately between at 21:30 and 22:30.'
	    ),
	    _react2.default.createElement('img', { src: _social6.default, className: _componentsModule2.default.content_image, alt: '' })
	  );
	};
	
	exports.default = SocialPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-social-js-a746d6bdbed4e5498555.js